import { endpoint } from "../../common/constant";

const { fetchAllPostPromisedData, fetchAllPromisedData } = require("../../common/utils/methods/commonMethods/utilityMethod");

export const searchPaymentMode=async(filterObj,page=0)=>{
    const req={...filterObj};
    const url=`${endpoint.paymentMode.search}?offset=${page}`;
    try{
    const res= await fetchAllPostPromisedData(url,req);
    if(res?.code===200){
        return res?.data
    }
    }
    catch(error){
        console.log(error)
    }
}

export const getAllActivePaymentCategory=async()=>{
    const req={};
    const url=endpoint.paymentMode.getAllActivePaymentCategory;
    try{
    const res= await fetchAllPromisedData(url)
    if(res?.code===200){
        return res?.data
    }
    }
    catch(error){
        console.log(error)
    }
}